import React from 'react';
import ReactDOM from 'react-dom/client';
//import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import store from './store/store';

// import { applyMiddleware } from 'redux';
// import thunk from 'redux-thunk';

// import reducers from './reducers';
// import logger from 'redux-logger';
// import { configureStore } from '@reduxjs/toolkit';

// const store = configureStore(reducers, applyMiddleware(thunk, logger));

// const ReactDOM = () => (
//   <Provider store={store}>
//     <App />
//   </Provider>
// );

// ReactDOM.render(
//   <Provider store={store}>
//     <App />
//   </Provider>,
//   document.getElementById('root')
// );

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

const root = ReactDOM.createRoot(document.getElementById('root'));

// root.render(
//   // <React.StrictMode>
//   //   <Provider store={store}>
//   //     <App />
//   //   </Provider>
//   // </React.StrictMode>
// );

root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
